import { render, staticRenderFns } from "./EvaluatorMenu.vue?vue&type=template&id=670db345&"
import script from "./EvaluatorMenu.vue?vue&type=script&lang=js&"
export * from "./EvaluatorMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports